import { render, staticRenderFns } from "./EditSubCategoryModal.vue?vue&type=template&id=37bba2da"
import script from "./EditSubCategoryModal.vue?vue&type=script&lang=js"
export * from "./EditSubCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports